import React from "react";
import {
    type Cell,
    type CellTemplate,
    type Compatible,
    type UncertainCompatible,
} from "@silevis/reactgrid";

export interface StatusDotGridCell extends Cell {
    type: "statusDot";
    text: string;
    showDot?: boolean;
    dotColor?: string;
    bgColor?: string;
}

const DEFAULT_DOT_COLOR = "#4CAF50";

/**
 * Lightweight cell template for the _order column.
 * Renders a drag-handle icon (☰) with an optional colored status dot.
 */
export class StatusDotCellTemplate implements CellTemplate<StatusDotGridCell> {
    getCompatibleCell(
        uncertainCell: UncertainCompatible<StatusDotGridCell>,
    ): Compatible<StatusDotGridCell> {
        return {
            ...uncertainCell,
            type: "statusDot",
            text: uncertainCell.text ?? "",
            value: NaN,
            showDot: uncertainCell.showDot ?? false,
            dotColor: uncertainCell.dotColor ?? DEFAULT_DOT_COLOR,
            bgColor: uncertainCell.bgColor ?? "transparent",
        };
    }

    isFocusable(): boolean {
        return false;
    }

    render(cell: Compatible<StatusDotGridCell>): React.ReactNode {
        const fillBg = cell.bgColor || "transparent";

        return (
            <div
                className="status-dot-cell"
                style={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "100%",
                    pointerEvents: "none",
                }}
            >
                {/* Background fill that extends into the overflow zone to mask scrolled content */}
                <div
                    style={{
                        position: "absolute",
                        left: -40,
                        width: 35,
                        height: 32,
                        backgroundColor: fillBg,
                    }}
                />
                {cell.showDot && (
                    <span
                        style={{
                            position: "absolute",
                            left: -20,
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            backgroundColor: cell.dotColor || DEFAULT_DOT_COLOR,
                            zIndex: 1,
                        }}
                    />
                )}
                <span style={{ opacity: 0.5 }}>{cell.text}</span>
            </div>
        );
    }
}
